import * as Yup from 'yup';

export const loginValidationSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  password: Yup.string()
    .min(8, 'Password is required')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password is required')
    .required('Password is required')
});

export const userValidationSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .matches(/^[a-zA-Z]+$/, 'First Name can only contain letters')
    .required('First Name is required'),
  lastName: Yup.string()
    .trim()
    .matches(/^[a-zA-Z]+$/, 'Last Name can only contain letters')
    .required('Last Name is required'),
  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required'),
  // phoneNumber: Yup.string()
  //   .matches(/^[0-9]{10}$/, 'Phone number must be a 10-digit number')
  //   .required('Phone number is required'),
  acceptTerms: Yup.boolean().oneOf(
    [true],
    'You must accept the Terms and Conditions'
  ),
  password: Yup.string()
    .trim()
    .min(8, 'Password must be at least 8 characters')
    .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
    .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
    .matches(/[0-9]/, 'Password must contain at least one number')
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      'Password must contain at least one special character'
    )
    .test('no-sequential-characters', 'Weak password', value => {
      const seqRegex =
        /(abc|bcd|cde|def|efg|fgh|ghi|jkl|mno|pqr|stu|vwxyz|qwerty)/i;
      return typeof value === 'string' && !seqRegex.test(value);
    })
    .required('Password is required'),
  confirmPassword: Yup.string()
    .trim()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Confirm Password is required')
});

export const ForgotPasswordValidationSchema = Yup.object({
  email: Yup.string()
    .email('Invalid email format')
    .required('Email is required')
});

export const ResetPasswordValidationSchema = Yup.object({
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      'Password must contain special characters'
    )
    .required('Password is required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Passwords must match')
    .required('Confirm password is required')
});

export const PropertyValidationSchema = Yup.object({
  name: Yup.string()
    .required('Property Name is required.')
    .matches(/^(?!\d+$).*$/, 'Property name cannot be only numbers.'),
  location: Yup.string()
    .required('Location is required.')
    .matches(/^(?!\d+$).*$/, 'Location cannot be only numbers.'),
  description: Yup.string().required('description is required.')
});

export const RooomDataValidationSchema = Yup.object({
  name: Yup.string().notRequired(),
  room_number: Yup.string()
    .matches(
      /^[A-Za-z0-9 ]+$/,
      'Room number must be alphanumeric and can contain spaces'
    )
    .required('Room number is required'),
  device_id: Yup.string()
    .required('Device ID is required')
    .matches(/^[A-Za-z0-9]+$/, 'Device ID must be alphanumeric')
});

export const ContactValidationSchema = Yup.object().shape({
  contactnumber: Yup.string()
    .matches(/^\d{10,15}$/, 'Invalid contact number')
    .required('Contact number is required'),
  email: Yup.string().email('Invalid email').required('Email is required'),
  name: Yup.string().min(2, 'Too short').required('Name is required')
});

export const Propertyschema = Yup.object().shape({
  propertyName: Yup.string().required('Property name is required'),
  location: Yup.string().required('Location is required'),
  latitude: Yup.string()
    .test('latitude-format', 'Latitude is required', value => {
      if (!value) return false;
      const decimalRegex = /^-?\d+(\.\d+)?$/;
      const degreesRegex = /^\d+(\.\d+)?°\s?[NS]$/;
      return decimalRegex.test(value) || degreesRegex.test(value);
    })
    .required('Latitude is required'),

  longitude: Yup.string()
    .test('longitude-format', 'Longitude is required', value => {
      if (!value) return false;
      const decimalRegex = /^-?\d+(\.\d+)?$/;
      const degreesRegex = /^\d+(\.\d+)?°\s?[EW]$/;
      return decimalRegex.test(value) || degreesRegex.test(value);
    })
    .required('Longitude is required'),
  size: Yup.number()
    .typeError('Size must be a valid number')
    .required('Size is required'),
  price: Yup.number()
    .typeError('Price must be a valid number')
    .required('Price is required'),
  description: Yup.string()
    .required('Description is required')
    .min(10, 'Description must be at least 10 characters'),
  images: Yup.array().test(
    'images-required',
    ' image is required',
    function (value) {
      const { imageUrls } = this.parent;
      return (imageUrls && imageUrls.length > 0) || (value && value.length > 0);
    }
  ),
  pdfFiles: Yup.array().test(
    'pdf-required',
    'PDF file is required',
    function (value) {
      const { pdfUrls } = this.parent;
      return (pdfUrls && pdfUrls.length > 0) || (value && value.length > 0);
    }
  )
});
